import Phaser from "phaser";
import VfxSprite from "./VfxSprite";

export default class Score extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, rotation, score, isTurn) {
        super(scene, x, y, 'all_images', 'score_turn_green');
        this.scene = scene;
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.constRotation = rotation;
        this.updateTurn(isTurn);
        this.updateScore(score);
        this.score21 = false;

    }

    updateTurn(isTurn, isStanding) {  //changes the colour of the container
        if (isTurn && !isStanding) { //GREEN
            this.setTexture('all_images', 'score_turn_green');
            this.setRotation(this.constRotation)
        }
        else if (!isTurn && !isStanding) { //RED
            this.setTexture('all_images', 'score_turn_red');
            this.setRotation(this.constRotation === 0 ? Math.PI : 0)
        }
        else if (isStanding) { //PURPLE
            this.setTexture('all_images', 'score_turn_purple');
            this.setRotation(this.constRotation === 0 ? Math.PI : 0)
        }
    }

    updateScore(score) { //changes the score text
        if (this.constRotation === 0) {
            if (this.scoreText === undefined){
                this.scoreText = this.scene.add.text(this.x, this.y + (20*this.scale), score.toString(), { fontSize: 104*this.scale + "px", fontFamily: "TruculentaBold", fill: '#000000', align: 'center' }).setOrigin(0.5, 0.5).setDepth(this.depth + 2);
            }
            else {
                this.scoreText.setText(score)
            }

        }
        else { //180 degree rotation
            if (this.scoreText === undefined) {
                this.scoreText = this.scene.add.text(this.x, this.y - (20*this.scale), score.toString(), { fontSize: 104*this.scale + "px", fontFamily: "TruculentaBold", fill: '#000000', align: 'center' }).setOrigin(0.5, 0.5).setDepth(this.depth + 2);
            }
            else {
               this.scoreText.setText(score)
            }        
        }
        if(score === 0){
            this.score21 = false;
        }
        //If score is 21, play animation
        if (score === 21 && !this.score21) {
            this.score21 = true; //so we don't repeat the animation
            new VfxSprite(this.scene, this.x, this.y, "star_burst", 0, { scale: this.scale, frames: 15, delay: 0 });
            //play sound
            this.scene.snd_house_power.play();
        }
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("score", function (x, y, scale, rotation, score, isTurn) {
    const scoreInst = new Score(this.scene, x, y, scale, rotation, score, isTurn);

    this.displayList.add(scoreInst);
    this.updateList.add(scoreInst);

    return scoreInst;
})